/**
 * Xsell Micro notification component
 * @module app/components/crossSell/signposting/XsellMicroNotification
 */
import jQuery from 'jquery';
import MessageBusTopics from '../../../../common/MessageBusTopics';

/**
 * Cross Sell Micro Notification class
 */
class XsellMicroNotification {

    /**
     * Create a xsell micro notification instance.
     * @constructor
     * @param {Object} options { container: {DOM element}, shouldExpire: {Boolean} }
     * @public
     */
    constructor(options) {
        this.container = options.container;
        this.shouldExpire = options.shouldExpire;
    }

    /**
     * Initialise
     * @returns {void}
     * @public
     */
    init() {
        this.messageBus = window.WH.messageBus;
        this.jqueryContainer = jQuery(this.container);
        this.microNotificationDomSelector = 'xsell-micro-notification-count';
        this.isMicroCountHidden = false;
        this.subscribeForEvents();
    }

    /**
     * Subscribers
     * @returns {void}
     * @public
     */
    subscribeForEvents() {

        this.messageBus.subscribe(MessageBusTopics.XSELL_MICRO_NOTIFICATION_PROVIDER_COUNT_UPDATE,
            this.updateCount.bind(this));

        if (this.shouldExpire) {
            this.messageBus.subscribe(MessageBusTopics.XSELL_MICRO_NOTIFICATION_PROVIDER_COUNT_EXPIRED,
                this.hideCount.bind(this));
        }
    }

    /**
     * Update the count in the micro notification
     * @returns {void}
     * @public
     */
    updateCount(message, data) {

        if (data.count === 0) {
            this.hideCount();
        } else if (!this.isMicroCountHidden) {
            this.jqueryContainer.html(`<span class="${this.microNotificationDomSelector}">${data.count}</span>`);
        }
    }

    /**
     * Hide the micro notification
     * @returns {void}
     * @public
     */
    hideCount() {

        this.isMicroCountHidden = true;
        this.jqueryContainer.find('.' + this.microNotificationDomSelector).hide();
    }
}

export default XsellMicroNotification;